/* eslint-disable */

import axios from "axios";

const url = require("../../client_config/config").url;

const state = {
  items: [],
  item: {},
  dashboard: "",
  monthlyAmountDialog: null,
  isLoading: false,
  CloseOut: null,
  isCloseOutDialogOpen: false
};

const getters = {
  isLoading: (state) => state.isLoading,
  finances: (state) => state.items,
  financeAmount: (state) => state.item,
  dashboard: (state) => state.dashboard,
  isCloseOutDialogOpen: state => state.isCloseOutDialogOpen
};

const actions = {
  async getClientFinances({ commit }, clientID) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/finances/${clientID}`);

      //CONVERT 2 DECIMAL PLACES
      response.data.data.forEach((element, index) => {
        var num = parseFloat(element?.Balance?.$numberDecimal);
        if (isNaN(num)) return (response.data.data[index].roundBalance = 0);
        response.data.data[index].roundBalance = num.toFixed(2);
      });

      commit("SET_CLIENT_FINANCES", response.data.data);
      commit("SET_LOADING", false);
      return response.data.data
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async getFinance({ commit }, financeID) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/finances/finance/${financeID}`);
      commit("SET_FINANCE", response.data.data);
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async getDashboardData({ commit }, clientID) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/finances/dashboard/${clientID}`);

      let data = response.data.data;

      const item = {};

      if (data != undefined) {
        Object.entries(data).forEach(([key, val]) => {
          var num = parseFloat(data[key]);
          item[key] = val;
          if (isNaN(item[key]) && item[key] != "Date") return (data[key] = 0);
          item[key] = num.toFixed(2);
        });
      }

      commit("SET_DASHBOARD_DATA", item);

      return response.data.data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async addFinance({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.post(`${url}/finances/`, data);
      // commit("ADD_FINANCE", response.data.data);
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      error.response;
    }
  },

  async addFinanceFromRollOver({ commit }, {data, id}) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.post(`${url}/finances/transaction/${id}`, data);
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      error.response;
    }
  },


  async updateFinance({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.put(
        `${url}/finances/${data.id}`,
        data.req_body
      );
      // commit("UPDATE_FINANCE", data.id);
      // commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      error.response;
    }
  },

  async updateStatus({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.put(`${url}/finances/closeout/${data.id}`, {
        CloseOut: data.CloseOut,
      });
      commit("UPDATE_STATUS", data);
      commit("SET_LOADING", false);
      console.log(response);
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  async deleteItem({ commit }, id) {
    try {
      const response = await axios.delete(`${url}/finances/${id}`);
      commit("DELETE_FINANCE", id);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  setCloseOutDialog({ commit }, data) {
    commit('SET_CLOSEOUT_DIALOG', data)
  },

};

const mutations = {
  SET_CLIENT_FINANCES(state, data) {
    state.items = [];
    data.map((item) => {
      let dt = new Date(item.Date);
      item.Date = dt.toISOString().substring(0, 10);
      state.items.push(item);
    });
  },

  SET_FINANCE(state, data) {
    state.item = data;
  },

  SET_DASHBOARD_DATA(state, data) {
    const isEmpty = Object.keys(data).length === 0;
    if (data === undefined || isEmpty) return (state.dashboard = "");
    state.dashboard = {
      ...data,
      Date: new Date(data?.Date).toISOString().substring(0, 10),
    };
  },
  ADD_FINANCE(state, data) {
    state.items.push({
      ...data,
      Date: new Date(data.Date).toISOString().substring(0, 10),
    });
  },

  UPDATE_FINANCE(state, id) {
    state.items.splice(
      state.items.findIndex((item) => item._id === id),
      1,
      {
        ...data,
        _id: id,
        Date: new Date(data.Date).toISOString().substring(0, 10),
      }
    );

    // state.items = data
    // state.items.push({
    //   ...data,
    //   Date: new Date(data.Date).toISOString().substring(0, 10),
    // });
  },

  DELETE_FINANCE(state, id) {
    state.items.splice(
      state.items.findIndex((finance) => finance._id === id),
      1
    );
  },

  UPDATE_STATUS(state, data) {
    let financeIndex = state.items.findIndex(
      (finance) => finance._id === data.id
    );
    state.items[financeIndex].CloseOut = data.CloseOut;
  },

  SET_MONTHLY_AMOUNT_DIALOG(state, data) {
    state.monthlyAmountDialog = data;
  },

  SET_NEW_FINANCES(state, data) {
    state.showNewfinance = data;
  },

  SET_FINANCE_DIALOG(state, data) {
    state.financeDialog = data;
  },

  SET_FINANCE_DATA(state, data) {
    state.financeData = data;
  },

  SET_LOADING(state, data) {
    state.isLoading = data;
  },

  SET_CLOSEOUT(state, data) {
    state.CloseOut = data;
  },

  SET_CLOSEOUT_DIALOG(state, data) {
    state.isCloseOutDialogOpen = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
